import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const Graph: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <>
      <path d="M8.4 7.625H7.1v32.65h32.65v-1.3H8.4V7.625Z" />
      <path
        fillRule="evenodd"
        d="M17.123 33.106a2.519 2.519 0 1 1-1.825-2.422l3.3-5.524a2.516 2.516 0 1 1 4.333-1.65L28 24.996a2.51 2.51 0 0 1 2.987-1.121l4.852-7.617a2.52 2.52 0 1 1 1.124.654L32.069 24.6a2.511 2.511 0 1 1-4.403 1.652l-5.114-1.498a2.515 2.515 0 0 1-2.843 1.082l-3.295 5.517c.44.454.71 1.072.71 1.753Zm-1.3 0a1.219 1.219 0 1 1-2.437 0 1.219 1.219 0 0 1 2.437 0Zm4.593-8.469a1.216 1.216 0 1 0 0-2.433 1.216 1.216 0 0 0 0 2.433Zm10.971 1.615a1.211 1.211 0 1 1-2.422 0 1.211 1.211 0 0 1 2.422 0Zm6.24-10.552a1.22 1.22 0 1 0 0-2.441 1.22 1.22 0 0 0 0 2.44Z"
      />
    </>
  );

  const normalHover = (
    <>
      <path d="M8.4 7.625H7.1v32.65h32.65v-1.3H8.4V7.625Z" />
      <path
        fillRule="evenodd"
        d="M17.123 33.106a2.519 2.519 0 1 1-1.927-2.448l3.65-8.264a2.522 2.522 0 1 1 3.852-.898l5.977 4.742a2.5 2.5 0 0 1 1.501-.498 2.5 2.5 0 0 1 1.213.312l4.121-4.244a2.498 2.498 0 1 1 .954.884l-4.138 4.26a2.511 2.511 0 1 1-4.457.306l-6.01-4.768a2.51 2.51 0 0 1-1.822.424l-3.696 8.368c.482.459.782 1.107.782 1.824Zm-1.3 0a1.219 1.219 0 1 1-2.437 0 1.219 1.219 0 0 1 2.437 0Zm4.593-11.463a1.222 1.222 0 1 0 0-2.444 1.222 1.222 0 0 0 0 2.444Zm10.971 6.609a1.211 1.211 0 1 1-2.422 0 1.211 1.211 0 0 1 2.422 0Zm6.24-6.574a1.198 1.198 0 1 0 0-2.397 1.198 1.198 0 0 0 0 2.397Z"
      />
    </>
  );

  return getIcon({ size, isHovered, normal, normalHover });
};

export default Graph;
